import './seatplan-example-directive-controller';
import template from './seatplan-example-directive.tpl.html';

/**
 * @ngdoc directive
 * @name festzelt-os.seatplans.directive:seatplan
 * @restrict EA
 * @element
 *
 * @description
 *
 * @example
 <example module="festzelt-os.seatplans">
 <file name="index.html">
 <seatplan-example></seatplan-example>
 </file>
 </example>
 *
 */
angular
    .module('festzelt-os.seatplans')
    .directive('seatplanExample', seatplan);

function seatplan() {
    return {
        restrict: 'EA',
        scope: {},
        templateUrl: template,
        replace: false,
        controllerAs: 'vm',
        controller: 'SeatplanExampleCtrl',
        bindToController: {
            seatplanId: '@',
            blockedElements: '='
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/pages/seatplans/directives/seatplan-example-directive.js